import PageSection from "../PageSection/PageSection";
import React, { useState, useEffect } from "react";
import bsBreakpoints from "bs-breakpoints";
import classNames from "classnames";
import ResponsivePageHeader from "../ResponsivePageHeader/ResponsivePageHeader";
import EventActivityCard from "../EventActivityCard/EventActivityCard";
import "./NIISEventsResponsive.scss";
import { niisevents } from "../../static-data/niisevents.data.js";

const NIISEventsResponsive = () => {
  const [currentBreakPoint, setCurrentBreakPoint] = useState("");

  useEffect(() => {
    bsBreakpoints.init();
    setCurrentBreakPoint(bsBreakpoints.getCurrentBreakpoint());

    const handleBreakPoint = (event) => {
      setCurrentBreakPoint(event.detail);
    };

    window.addEventListener("new.bs.breakpoint", handleBreakPoint);

    return () => {
      window.removeEventListener("new.bs.breakpoint", handleBreakPoint);
    };
  }, []);
  const descriptionClasses = classNames("mb-4 text-center text-text-color", {
    "font-sm": currentBreakPoint === "xSmall" || currentBreakPoint === "small",
  });

  return (
    <PageSection bgClass="background-color">
      <ResponsivePageHeader centered={true} title="NIIS Events" />
      <p className={descriptionClasses}>
        At NIIS, Dreamfest is a yearly celebration of societies and their
        activities. The event, which was planned by PG management students, is
        the ideal fusion of frolic and pleasure, thrill and ecstasy, passion and
        dedication. DreamFest is a wonderful venue for the magnificent showcase
        of the many talents of today's youngsters, and it always has a social
        undercurrent.
      </p>
      <div className="events-container">
        {niisevents.map((activity) => (
          <EventActivityCard key={activity.id} {...activity} />
        ))}
      </div>
    </PageSection>
  );
};

export default NIISEventsResponsive;
